<script lang="ts">
	import type { Device } from 'src/types/Device';
	import EmeterPriorityView from 'src/components/Sidepanel/DeviceViews/Emeter/EmeterPriorityView.svelte';
	// import SidepanelMainViewHost from 'src/components/Sidepanel/SidepanelMainViewHost.svelte';

	export let device: Device;
</script>

<EmeterPriorityView {device} />
<!-- <SidepanelMainViewHost {device} /> -->
